import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Switch } from "antd";
import {
  togglePressEnterToSendMessage,
  toggleDynamicMessageFilter,
  toggleAlwaysOpenNewMessages,
  toggleReceiveEmailNotifications,
  toggleReceiveMentionEmailNotifications,
} from "../../store/actions/general-settings";
import UserService from "../../services/user";
import "./OptionsBox.scss";

class OptionsBox extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.onMoreOptionsClick = this.onMoreOptionsClick.bind(this);
    this.toggleDynamicMessageFilter =
      this.toggleDynamicMessageFilter.bind(this);
    this.toggleAlwaysOpenNewMessages =
      this.toggleAlwaysOpenNewMessages.bind(this);
    this.togglePressEnterToSendMessage =
      this.togglePressEnterToSendMessage.bind(this);
    this.toggleReceiveEmailNotifications =
      this.toggleReceiveEmailNotifications.bind(this);
    this.toggleReceiveMentionEmailNotifications =
      this.toggleReceiveMentionEmailNotifications.bind(this);
  }

  onOptionClick(e) {
    e.stopPropagation();
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      event.target !== null
    ) {
      event.stopPropagation();
      this.props.onClickAway();
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  onMoreOptionsClick() {
    this.props.toggleMoreOptions();
  }

  toggleDynamicMessageFilter() {
    this.props.toggleDynamicMessageFilter();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: !this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleAlwaysOpenNewMessages() {
    this.props.toggleAlwaysOpenNewMessages();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: !this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  togglePressEnterToSendMessage() {
    this.props.togglePressEnterToSendMessage();
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: !this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });
  }

  toggleReceiveEmailNotifications() {
    const newValue = !this.props.options.receiveEmailNotifications;
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: newValue,
      notifyOnMentionOnly: newValue
        ? false
        : this.props.options.receiveMentionEmailNotifications,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });

    this.props.toggleReceiveEmailNotifications();

    if (newValue && this.props.options.receiveMentionEmailNotifications) {
      this.props.toggleReceiveMentionEmailNotifications();
    }
  }

  toggleReceiveMentionEmailNotifications() {
    const newValue = !this.props.options.receiveMentionEmailNotifications;
    UserService.updateUserConfiguration({
      id: this.props.options.id,
      dynamicMessageFilter: this.props.options.dynamicMessageFilter,
      alwaysOpenNewMessages: this.props.options.alwaysOpenNewMessages,
      alwaysNotifyByEmail: newValue
        ? false
        : this.props.options.receiveEmailNotifications,
      notifyOnMentionOnly: newValue,
      pressEnterToSendMessages: this.props.options.pressEnterToSendMessage,
      filterMessageStatus: "ACTIVE",
    });

    this.props.toggleReceiveMentionEmailNotifications();

    if (newValue && this.props.options.receiveEmailNotifications) {
      this.props.toggleReceiveEmailNotifications();
    }
  }

  render() {
    const {
      dynamicMessageFilter,
      alwaysOpenNewMessages,
      pressEnterToSendMessage,
      receiveEmailNotifications,
      receiveMentionEmailNotifications,
    } = this.props.options;

    return (
      <div
        className={`options-box ${this.props.direction}`}
        onClick={(e) => e.stopPropagation()}
        ref={this.setWrapperRef}
      >
        <span className="options-box-title">
          <FormattedMessage id="chat.settings" />
        </span>

        <div className="options-box-options-container">
          <div className="options-box-option" onClick={this.onOptionClick}>
            <span className="option-label">
              <FormattedMessage id="settings.dynamicMessage" />
            </span>

            <Switch
              defaultChecked={dynamicMessageFilter}
              onChange={this.toggleDynamicMessageFilter}
            />
          </div>

          <div className="options-box-option" onClick={this.onOptionClick}>
            <span className="option-label">
              <FormattedMessage id="settings.alwaysOpenNewMessages" />
            </span>

            <Switch
              defaultChecked={alwaysOpenNewMessages}
              onChange={this.toggleAlwaysOpenNewMessages}
            />
          </div>

          <div className="options-box-option" onClick={this.onOptionClick}>
            <span className="option-label">
              <FormattedMessage id="settings.pressEnterToSendMessage" />
            </span>

            <Switch
              defaultChecked={pressEnterToSendMessage}
              onChange={this.togglePressEnterToSendMessage}
            />
          </div>

          <div className="options-box-option" onClick={this.onOptionClick}>
            <span className="option-label">
              <FormattedMessage id="settings.receiveEmailNotifications" />
            </span>

            <Switch
              checked={receiveEmailNotifications}
              onChange={this.toggleReceiveEmailNotifications}
            />
          </div>

          <div className="options-box-option" onClick={this.onOptionClick}>
            <span className="option-label">
              <FormattedMessage id="settings.receiveMentionEmailNotifications" />
            </span>

            <Switch
              checked={receiveMentionEmailNotifications}
              onChange={this.toggleReceiveMentionEmailNotifications}
            />
          </div>
        </div>

        <div className="more-options" onClick={this.onMoreOptionsClick}>
          <FormattedMessage id="settings.more" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    options: state.GeneralSettings,
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleDynamicMessageFilter: (id) => dispatch(toggleDynamicMessageFilter()),
  toggleAlwaysOpenNewMessages: (id) => dispatch(toggleAlwaysOpenNewMessages()),
  togglePressEnterToSendMessage: (id) =>
    dispatch(togglePressEnterToSendMessage()),
  toggleReceiveEmailNotifications: (id) =>
    dispatch(toggleReceiveEmailNotifications()),
  toggleReceiveMentionEmailNotifications: (id) =>
    dispatch(toggleReceiveMentionEmailNotifications()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OptionsBox);
